import * as React from 'react';

const GoogleIcon$2 = (props)=>/*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        fill: "none",
        ...props
    }, /*#__PURE__*/ React.createElement("path", {
        fill: "#4285F4",
        d: "M18.82 10.2q0-.95-.16-1.84h-8.48v3.49h4.84a4.2 4.2 0 0 1-1.8 2.7v2.27h2.92a8.8 8.8 0 0 0 2.68-6.62"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#34A853",
        d: "M10.18 19c2.43 0 4.47-.8 5.96-2.18l-2.92-2.26c-.8.54-1.83.86-3.04.86a5.4 5.4 0 0 1-5.04-3.7h-3v2.32A9 9 0 0 0 10.19 19"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#FBBC05",
        d: "M5.14 11.71a5.4 5.4 0 0 1 0-3.42V5.97h-3a8.9 8.9 0 0 0 0 8.06l2.34-1.81z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#EA4335",
        d: "M10.18 4.58q2.01 0 3.44 1.35l2.58-2.58A8.98 8.98 0 0 0 2.14 5.97l3 2.32a5.4 5.4 0 0 1 5.04-3.7"
    }));

export { GoogleIcon$2 as GoogleIcon };
//# sourceMappingURL=Google.mjs.map
